import React from "react";
import PropTypes from "prop-types";
import { StyledContainer } from "./Flex.styles";
const Flex = ({ justify, align, direction, wrap, style, gap, children }) => {
  return (
    <StyledContainer
      justify={justify}
      align={align}
      direction={direction}
      wrap={wrap}
      style={style}
      gap={gap}
    >
      {children}
    </StyledContainer>
  );
};
Flex.defaultProps = {
  justify: "flex-start",
  align: "center",
  direction: "row",
  wrap: "nowrap",
  gap: "8px",
};
Flex.propTypes = {
  justify: PropTypes.oneOf([
    "center",
    "flex-start",
    "flex-end",
    "space-between",
    "space-around",
  ]),
  align: PropTypes.oneOf(["center", "flex-start", "flex-end"]),
  direction: PropTypes.oneOf([
    "row",
    "column",
    "row-reverse",
    "column-reverse",
  ]),
  wrap: PropTypes.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  gap: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};
export default Flex;
